import styled from "styled-components";
import { colors, types } from "../../../libs";

export const Container = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 24px;
  justify-content: space-between;

  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const Title = styled.h1`
  ${types.headers.secondary};
  background: ${colors.text.textGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
`;

export const Description = styled.p`
  color: ${colors.text.gray};
  margin: 8px 0 0;
`;

export const SaveButtonWrapper = styled.div`
  min-width: 190px;
`;

export const Slots = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 28px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

export const Slot = styled.section`
  background: ${colors.background.lightBlack};
  border: 1px solid ${colors.background.lightWhite};
  border-radius: 10px;
  min-width: 0;
  padding: 14px;
`;

export const SlotHeader = styled.div`
  align-items: center;
  color: ${colors.text.white};
  display: flex;
  font-weight: 600;
  justify-content: space-between;
  margin-bottom: 14px;
`;

export const IconActions = styled.div`
  display: flex;
  gap: 6px;
`;

export const IconButton = styled.button`
  align-items: center;
  background: transparent;
  border: 1px solid ${colors.background.lightWhite};
  border-radius: 4px;
  color: ${colors.text.green};
  display: inline-flex;
  height: 30px;
  justify-content: center;
  width: 30px;

  &:disabled {
    color: ${colors.text.disabled};
    cursor: not-allowed;
  }
`;

export const FieldLabel = styled.label`
  ${types.body.small};
  color: ${colors.text.gray};
  display: block;
  margin: 12px 0 5px;
`;

export const SwitchRow = styled.div`
  align-items: center;
  background: ${colors.background.formField};
  color: ${colors.text.mediumWhite};
  display: flex;
  justify-content: space-between;
  min-height: 50px;
  margin-top: 14px;
  padding: 0 10px 0 15px;
`;

export const SwitchLabel = styled.label`
  ${types.body.normal};
  color: ${colors.text.disabled};
  cursor: pointer;
`;

export const Preview = styled.div`
  padding: 18px 0 0 !important;

  .package-card {
    height: 100%;
    margin: 0 auto;
    max-width: none;
  }
`;

export const AddButton = styled.button`
  align-items: center;
  background: ${colors.background.linearGradient};
  border: 1px solid ${colors.background.darkGreen};
  border-radius: 6px;
  color: ${colors.text.green};
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 16px;
  padding: 12px 18px;
  width: 100%;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
